import { Text, View } from '@react-pdf/renderer';
import { MyFleetVessel } from '../../../models/my-fleet.model';
import {
  getProVesselTypeLabel,
  getRiskLevelColor,
  isRiskLevelRecord,
  ProVesselTypes,
  RiskLevel,
} from '../../../models/pro.model';
import styles, { borderStyles } from '../pro-report-pdf-styles';

interface VesselDetailsProps {
  vessel: MyFleetVessel | undefined;
  riskLevel: RiskLevel | Record<ProVesselTypes, RiskLevel>;
}

function VesselDetails({ vessel, riskLevel }: VesselDetailsProps) {
  if (!vessel || !riskLevel) {
    return null;
  }

  let vesselTypeHeaderText = 'Vessel type';
  let vesselTypeLabel = 'Unknown';
  let riskLevelValue: RiskLevel | string = 'Unknown';
  let showUnknownTypeMessage = false;

  if (
    vessel.vessel_type &&
    vessel.vessel_type !== ProVesselTypes.UNKNOWN &&
    Object.values(ProVesselTypes).includes(vessel.vessel_type as ProVesselTypes)
  ) {
    vesselTypeLabel = getProVesselTypeLabel(
      vessel.vessel_type as ProVesselTypes
    );
    riskLevelValue = isRiskLevelRecord(riskLevel)
      ? riskLevel[vessel.vessel_type as ProVesselTypes]
      : riskLevel;
  } else {
    showUnknownTypeMessage = true;
    vesselTypeHeaderText = 'Vessel type*';
    riskLevelValue = isRiskLevelRecord(riskLevel) ? 'Unknown' : riskLevel;
  }

  return (
    <View wrap={false} style={styles.table}>
      <View style={styles.vesselDetailsTableHeader}>
        <Text
          style={{
            ...styles.vesselDetailsTableCell,
            ...borderStyles,
            borderRight: '1px',
            width: '34%',
          }}
        >
          Vessel name
        </Text>
        <Text
          style={{
            ...styles.vesselDetailsTableCell,
            ...borderStyles,
            borderRight: '1px',
            width: '22%',
            flexGrow: 1,
          }}
        >
          Vessel IMO
        </Text>
        <Text
          style={{
            ...styles.vesselDetailsTableCell,
            ...borderStyles,
            borderRight: '1px',
            width: '22%',
            flexGrow: 1,
          }}
        >
          {vesselTypeHeaderText}
        </Text>
        {!showUnknownTypeMessage && (
          <Text style={{ ...styles.vesselDetailsTableCell, width: '22%' }}>
            Port claims risk*
          </Text>
        )}
      </View>

      <View style={styles.vesselDetailsTableRow} key={vessel.vessel_type}>
        <Text
          style={{
            ...styles.vesselDetailsTableCell,
            ...borderStyles,
            borderRight: '1px',
            width: '34%',
          }}
        >
          {vessel.name || 'Unknown'}
        </Text>
        <Text
          style={{
            ...styles.vesselDetailsTableCell,
            ...borderStyles,
            borderRight: '1px',
            width: '22%',
            flexGrow: 1,
          }}
        >
          {vessel.imo || 'Unknown'}
        </Text>
        <Text
          style={{
            ...styles.vesselDetailsTableCell,
            ...borderStyles,
            borderRight: '1px',
            width: '22%',
            flexGrow: 1,
          }}
        >
          {vesselTypeLabel}
        </Text>
        {!showUnknownTypeMessage && (
          <Text
            style={{
              ...styles.vesselDetailsTableCell,
              width: '22%',
              color: getRiskLevelColor(riskLevel as RiskLevel),
              fontWeight: 'bold',
            }}
          >
            {riskLevelValue}
          </Text>
        )}
      </View>
      <Text style={styles.textAsterix}>
        {showUnknownTypeMessage
          ? '*Generic PRO report has been generated as vessel type could not be identified.'
          : "*Risk levels by vessel type are based on NorthStandard's claims experience and/or correspondents' advice as outlined below."}
      </Text>
    </View>
  );
}

export default VesselDetails;
